import React from 'react';
import './About.css';
import logo from '../../img/logo3.jpg';
import { 
  FaShieldAlt, 
  FaStar, 
  FaCogs, 
  FaLightbulb, 
  FaHeadset,
  FaCheck 
} from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-page">
      <section className="page-header">
        <h1>Infosfera</h1>
        <p>Conheça nossa história e valores</p>
      </section>
      
      <div className="container">
        <section className="history-section">
          <div className="history-content">           
            <div className="history-text">
              <h2>Nossa História</h2>
              <p>Desde a sua fundação, a Infosfera nasceu com a missão de transformar negócios através da tecnologia.
                 O que começou como uma pequena equipe apaixonada por inovação tornou-se hoje uma referência em soluções 
                 digitais completas na região.
              </p>
              <p>Ao longo dos anos, ajudamos empresas de diferentes portes e setores a modernizarem-se, melhorarem a sua 
                eficiência e conquistarem novos mercados — sempre com um compromisso inabalável com <strong>responsabilidade, 
                qualidade e confiança.</strong>
              </p>
              <p>Nossa trajetória é marcada por projetos que vão desde a <strong>digitalização de processos até o desenvolvimento 
                de software sob medida, consultoria em TI, cibersegurança, suporte e manutenção especializados, desenho e 
                implementação de projetos informáticos, computação em nuvem e virtualização.</strong>
              </p>
            </div>
          
            <div className="history-image">
              <img 
                src={logo} 
                alt="Logo da Infosfera" 
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/400x500/3498db/ffffff?text=Infosfera+Logo';
                }}
              />
              <div className="image-caption">
                <p>Sua parceira em soluções tecnológicas</p>
              </div>
            </div>
          </div>
        </section>

        <section className="why-choose-section">
          <h2>Por que escolher a Infosfera</h2>
          <div className="reasons-grid">
            <div className="reason-item">
              <div className="reason-icon">
                <FaShieldAlt /> 
              </div>
              <div className="reason-content">
                <h4>Confiança que se constrói</h4>
                <p>Cada projeto é tratado com total transparência e compromisso.</p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                <FaStar />
              </div>
              <div className="reason-content">
                <h4>Qualidade comprovada</h4>
                <p>Trabalhamos com padrões técnicos e metodologias que garantem resultados consistentes.</p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                <FaCogs />
              </div>
              <div className="reason-content">
                <h4>Soluções personalizadas</h4>
                <p>Cada cliente é único, e as nossas soluções são adaptadas às suas necessidades e objetivos.</p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                <FaLightbulb />
              </div>
              <div className="reason-content">
                <h4>Inovação responsável</h4>
                <p>Utilizamos tecnologia de ponta sem descuidar da segurança, sustentabilidade e ética.</p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                <FaHeadset />
              </div>
              <div className="reason-content">
                <h4>Apoio contínuo</h4>
                <p>Do planeamento à manutenção, acompanhamos cada etapa para que o cliente tenha tranquilidade total.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="mission-section">
          <div className="mission-card">
            <h3>Missão</h3>
            <p>Fornecer soluções tecnológicas inovadoras e seguras que acelerem o crescimento dos nossos clientes,
               simplifiquem processos e elevem a qualidade das suas operações, superando expectativas com <strong>responsabilidade, qualidade e confiança.</strong></p>
          </div>
          
          <div className="mission-card">
            <h3>Visão</h3>
            <p>Ser reconhecida como a empresa de tecnologia mais confiável e inovadora da região, referência em <strong> 
              excelência técnica, ética e satisfação do cliente,</strong> contribuindo para um futuro digital mais seguro, 
              eficiente e sustentável.</p>
          </div>
          
          <div className="mission-card">
            <h3>Valores</h3>
            <ul>
              <li><strong>Inovação constante</strong> — Buscar sempre novas formas de criar valor para nossos clientes.</li>
              <li><strong>Transparência</strong> — Clareza em todas as etapas e decisões.</li>
              <li><strong>Compromisso com resultados</strong> — Foco em atingir e superar metas.</li>
              <li><strong>Satisfação do cliente</strong> — Entregar mais do que prometemos.</li>
              <li><strong>Responsabilidade</strong> — Garantir segurança, conformidade e impacto positivo em cada projeto.</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;